import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import { useBulkUnassignPassengersFromTask } from "@/requests/tracking.mutations";

function useBulkUnassignPassengers() {
    const { mutateAsync, isPending } = useBulkUnassignPassengersFromTask();
    const { t } = useTranslation();

    const handleBulkUnassignPassengers = async (ids: string[]) => {
        if (isPending || !ids.length) return;
        await mutateAsync({ operationsIds: ids });

        enqueueSnackbar(
            t("responses.bulkTaskUnassign", {
                count: ids.length || 1,
            }),
            {
                variant: "success",
            }
        );
    };

    return { handleBulkUnassignPassengers, unassignPending: isPending };
}

export default useBulkUnassignPassengers;
